import { BTreeServant } from './data_types/b_tree_servant';
import { ColorUtility } from './types/color';
import { IteratorUtility } from './types/iterator';
import { NumberUtility } from './types/number';
import { PhoneNumberUtility } from './types/phone_number';
import { StringUtility } from './types/string';
import { TimeUtility } from './types/time';

/**
 * @Type
 */
export * from './types/color';
export * from './types/time';
export * from './types/string';
export * from './types/number';
export * from './types/phone_number';
export * from './types/iterator';

export * from './data_types/b_tree_servant';

export * from './core/regular_expression';
export * from './core/types';

/**
 * @deprecated all utilities are added by name
 */
export class TypeUtility {
  static BTreeServant: typeof BTreeServant = BTreeServant;
  static PhoneNumberUtility: typeof PhoneNumberUtility = PhoneNumberUtility;
  static StringUtility: typeof StringUtility = StringUtility;
  static NumberUtility: typeof NumberUtility = NumberUtility;
  static ColorUtility: typeof ColorUtility = ColorUtility;
  static TimeUtility: typeof TimeUtility = TimeUtility;
  static IteratorUtility: typeof IteratorUtility = IteratorUtility;

  // deprecated
  static phoneNumber: typeof PhoneNumberUtility = PhoneNumberUtility;
  static string: typeof StringUtility = StringUtility;
  static number: typeof NumberUtility = NumberUtility;
  static color: typeof ColorUtility = ColorUtility;
  static time: typeof TimeUtility = TimeUtility;
}

/*
- Every Data Type
- Color
- Date/Time
- Higher-order functions on top of Lodash
*/



// WEBPACK FOOTER //
// ./app/vendor/utility-ts-type/src/main.ts